function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import { getFundMainClass, getFundsSheetPath, getPeriodsPerformance } from '@finect/front-resources/Products';
import { uniq } from '@finect/front-utils/uniq';
import { isArray } from '@finect/front-utils/isArray';
import { feeTypes, periods } from '../../utils';
import { getChartSeriesColors } from '../utils';
export var reduceFee = function reduceFee(fund, feeType) {
  if (fund.fees) {
    return (fund.fees || []).find(function (_ref) {
      var type = _ref.type;
      return type === feeType;
    });
  }
  var fundClass = getFundMainClass(fund);
  var data = fundClass && isArray(fundClass.fees) ? fundClass.fees.find(function (fee) {
    return fee.type === feeType;
  }) : null;
  if (data) {
    return data;
  }
  return fundClass && _typeof(fundClass.fees) === 'object' && fundClass.fees.hasOwnProperty(feeType.toLowerCase()) ? fundClass.fees[feeType.toLowerCase()] : null;
};
var reduceStat = function reduceStat(stats, statType, periodCode) {
  var data = stats.hasOwnProperty(statType) ? stats[statType] : null;
  return (data || []).find(function (stat) {
    return stat.period === periodCode;
  });
};
var DIMENSIONS = {
  performance: function performance(axisData, fund) {
    return getPeriodsPerformance((fund.stats || fund).performance.periods, axisData.period, axisData.type);
  },
  fee: function fee(axisData, fund) {
    return reduceFee(fund, axisData.fee);
  },
  stat: function stat(axisData, fund) {
    return reduceStat(fund.stats || fund, axisData.stat, axisData.period);
  }
};
var getAxisValue = function getAxisValue(axisData, fund) {
  return DIMENSIONS[axisData.dimension](axisData, fund);
};
export var doSeries = function doSeries(funds, colors, sizes, contextFunds, theme, xAxis, yAxis, productType, onProductClick) {
  var fundsSerie = {
    name: productType.shortSingular,
    data: [],
    zIndex: 1,
    marker: {
      symbol: 'circle'
    }
  };
  var fundsSerieHighlight = {
    zIndex: 2,
    name: productType.shortSingular,
    data: [],
    marker: {
      symbol: 'circle'
    }
  };
  var themeColors = colors || getChartSeriesColors(theme);
  var contextIds = contextFunds.map(function (item) {
    return item.id;
  });
  var fundClassesWithValidData = [];
  function doFund(fund, serie) {
    if (fund) {
      var xAxisValue = getAxisValue(xAxis, fund);
      var yAxisValue = getAxisValue(yAxis, fund);
      if (xAxisValue && yAxisValue) {
        var colorIndex = contextIds.indexOf(fund.id) % themeColors.length;
        if (contextIds.includes(fund.id)) fundClassesWithValidData.push(fund.id);
        serie.data.push({
          id: fund.id,
          name: fund.name,
          x: xAxisValue.value,
          y: yAxisValue.value,
          url: getFundsSheetPath(theme, productType, fund),
          marker: {
            radius: contextIds.includes(fund.id) ? sizes && sizes[fund.id] || theme.chartsScatterPointRadiusActive : theme.chartsScatterPointRadius,
            fillColor: contextIds.includes(fund.id) ? themeColors[colorIndex] : theme.chartsScatterPointColor,
            lineColor: contextIds.includes(fund.id) ? 'black' : theme.chartsScatterPointColor,
            borderColor: contextIds.includes(fund.id) ? 'black' : theme.chartsScatterPointColor
          },
          events: {
            click: function click(event) {
              onProductClick(event.point.url);
            }
          }
        });
      }
    }
  }
  _toConsumableArray(funds).forEach(function (fund) {
    return doFund(fund, fundsSerie);
  });
  _toConsumableArray(contextFunds).forEach(function (fund) {
    return doFund(fund, fundsSerieHighlight);
  });
  return {
    series: [fundsSerie, fundsSerieHighlight],
    fundClassesWithValidData: uniq(fundClassesWithValidData)
  };
};
export { feeTypes, periods };